// removed by extract-text-webpack-plugin
module.exports = {"hidden":"_2HQBQ","visuallyhidden":"c3wl7","hide-text":"_3Yni9","center":"OCte3","noprint":"_19Tpc","skip":"_21ZZe"};


/*****************
 ** WEBPACK FOOTER
 ** ./themes/ui-skip-to-content/styles/default.scss
 ** module id = 1016
 ** module chunks = 2
 **/